export const validatePageConfig = (config) =>
    Boolean(config && config.slots && config.slots.length !== 0);
